<script setup lang="ts">
import { useLoginStore } from "@/stores/login";
import { onMounted } from "vue";

const loginStore = useLoginStore();

onMounted(() => {
    loginStore.updateLoginState();
});

</script>

<template>
    <li class="me-0 me-md-4 text-center text-lg-end my-3 my-lg-0">
        <div class="small-telephone">
            If you need some help, call us free on:
            <a
                class="telephone-head text-right text-nowrap link-underline link-underline-opacity-0 link-underline-opacity-100-hover"
                href="tel:08003265479"
            >
                0800 326 5479
            </a>
        </div>
        <div class="small-telephone font-weight-light">
            or email <a
                class="text-right link-underline link-underline-opacity-0 link-underline-opacity-100-hover"
                href="mailto:hello@annuityready.com"
            >hello@annuityready.com </a>- we may
            record and monitor calls
        </div>
    </li>
    <li class="boxed text-center">
        <router-link
            v-if="loginStore.isLoggedIn"
            id="header-login"
            to="/logout"
        >
            Logout
        </router-link>
        <router-link
            v-else
            id="header-login"
            to="/login"
        >
            Login
        </router-link>
    </li>
</template>
